'use client';
import { styled } from 'styled-components';
import PagingButton from '../atoms/PagingButton';
import useWidth from '@/util/useWidth';
import { BREAKPOINT_PC, BREAKPOINT_SP } from '@/util/const';
import ContentText from '../atoms/ContentText';

type PagingBarProps = {
  current: number;
  total: number;
  onClick?: (n: number) => void;
  className?: string;
  size?: 'large' | 'small';
  renderUrl?: (n: number) => string;
  numStart?: number;
  numEnd?: number;
  numTotal?: number;
};

export default function PagingBar(props: PagingBarProps) {
  const { isMobile } = useWidth();
  const pageList = Array.from({ length: props.total });

  var ellipsis = <Ellipsis />;

  if (props.total === 0) {
    return null; // ページ数が0の場合は何も表示しない
  }

  return (
    <MobileWrapper>
      {isMobile && props.numStart && props.numEnd && props.numTotal ? (
        <ContentText type="article-l" className="textClass">
          {props.numStart}-{props.numEnd}件 / 全{props.numTotal}件中
        </ContentText>
      ) : (
        <></>
      )}
      <Container className={props.className}>
        {!isMobile && props.total > 1 && (
          <PagingButton
            size={props.size}
            type="left"
            status={props.current == 1 ? 'disabled' : 'active'}
            onClick={() => {
              props.current > 1 &&
                props.onClick &&
                props.onClick(props.current - 1);
            }}
            url={props.renderUrl && props.renderUrl(props.current - 1)}
          ></PagingButton>
        )}
        {pageList.map((v: any, i) => {
          const show =
            i < 1 ||
            i >= pageList.length - 1 ||
            (i + 3 >= props.current && i - 1 <= props.current);
          if (!show) {
            if (i == props.current - 4 || i == props.current + 2) {
              ellipsis = <Ellipsis />;
            } else {
              ellipsis = <></>;
            }
          }

          return show ? (
            <PagingButton
              key={i}
              size={props.size}
              type="number"
              number={i + 1}
              status={props.current == i + 1 ? 'normal' : 'active'}
              onClick={() => {
                props.current != i + 1 && props.onClick && props.onClick(i + 1);
              }}
              url={props.renderUrl && props.renderUrl(i + 1)}
            ></PagingButton>
          ) : (
            ellipsis
          );
        })}
        {!isMobile && props.total > 1 && (
          <PagingButton
            size={props.size}
            type="right"
            status={props.total == props.current ? 'normal' : 'active'}
            onClick={() => {
              props.current < props.total &&
                props.onClick &&
                props.onClick(props.current + 1);
            }}
            url={props.renderUrl && props.renderUrl(props.current + 1)}
          ></PagingButton>
        )}
      </Container>
      {isMobile && props.total > 1 ? <hr className="blackHr" /> : <></>}
      {isMobile && props.total > 1 && (
        <>
          <div className="page-buttons-mobile">
            <PagingButton
              size={props.size}
              type="prev"
              status={props.current === 1 ? 'disabled' : 'active'}
              onClick={() => {
                props.current > 1 &&
                  props.onClick &&
                  props.onClick(props.current - 1);
              }}
              url={props.renderUrl && props.renderUrl(props.current - 1)}
              className="leftPrev"
            ></PagingButton>
            <PagingButton
              size={props.size}
              type="next"
              status={props.current === props.total ? 'disabled' : 'active'}
              onClick={() => {
                if (props.current < props.total) {
                  props.onClick && props.onClick(props.current + 1);
                }
              }}
              url={props.renderUrl && props.renderUrl(props.current + 1)}
              className="rightNext"
            />
          </div>
        </>
      )}
    </MobileWrapper>
  );
}
const Ellipsis = styled.div`
  font-family: 'Noto Sans JP';
  font-size: 24px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0.0125em;
  text-align: center;
  color: var(--tag-disabled, #8e8e8e);
  &::before {
    content: '...';
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  a {
    color: inherit;
    text-decoration: none;
  }
`;

const MobileWrapper = styled.div`
  @media (max-width: ${BREAKPOINT_SP}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    padding: 12px 0px;
    margin: 0 -16px;
    background-color: var(--bg-tertiary-gray-100);

    .page-buttons-mobile {
      display: flex;
      width: calc(100vw - 32px);
      justify-content: space-between;
    }
    .blackHr {
      border-top: 1px solid var(--gray-300-border);
      width: calc(100vw);
      margin: 12px 0px;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    .textClass {
      padding-bottom: 12px;
    }
  }
`;
